import AFindInPageSearch from './index.vue';

AFindInPageSearch.install = app => {
  app.component(AFindInPageSearch.name, AFindInPageSearch);
};

export default AFindInPageSearch;
